"use client";

import { Star, Quote } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export default function Testimonials() {
    const testimonials = [
        {
            name: "Ahmed Khan",
            location: "Dubai, UAE",
            image: "https://i.pravatar.cc/150?img=12",
            review:
                "Amazing experience! We found a luxury hotel in Dubai at a much lower price than other booking websites.",
        },
        {
            name: "Sarah Williams",
            location: "London, UK",
            image: "https://i.pravatar.cc/150?img=32",
            review:
                "Booking was smooth and instant. Customer support was incredibly helpful throughout the trip.",
        },
        {
            name: "Mohammed Ali",
            location: "Abu Dhabi, UAE",
            image: "https://i.pravatar.cc/150?img=15",
            review:
                "Excellent hotel deals and verified listings. Highly recommended for UAE travelers.",
        },
        {
            name: "Jessica Brown",
            location: "Manchester, UK",
            image: "https://i.pravatar.cc/150?img=20",
            review:
                "The hotel matched exactly what was shown online. Great prices and a seamless booking process.",
        },
        {
            name: "Ali Hassan",
            location: "Sharjah, UAE",
            image: "https://i.pravatar.cc/150?img=18",
            review:
                "I booked a family staycation through the platform and saved a lot compared to other sites.",
        },
    ];

    return (
        <section className="py-24 bg-white dark:bg-gray-950">
            <div className="container mx-auto px-6">

                {/* Header */}
                <div className="text-center mb-16">

                    <span className="inline-block px-4 py-2 rounded-full bg-blue-100 text-blue-600 text-sm font-semibold mb-4">
                        Testimonials
                    </span>

                    <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
                        What Our Travelers Say
                    </h2>

                    <p className="max-w-2xl mx-auto text-gray-600 dark:text-gray-400">
                        Trusted by thousands of travelers across the UAE.
                    </p>

                </div>

                <Swiper
                    modules={[Autoplay, Pagination]}
                    spaceBetween={30}
                    slidesPerView={1}
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    breakpoints={{
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                        },
                    }}
                >
                    {testimonials.map((item, index) => (
                        <SwiperSlide key={index}>

                            <div className="bg-white dark:bg-gray-800 rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 h-full">

                                <Quote
                                    size={40}
                                    className="text-blue-500 mb-5"
                                />

                                <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-6">
                                    {item.review}
                                </p>

                                <div className="flex mb-5">
                                    {[...Array(5)].map((_, i) => (
                                        <Star
                                            key={i}
                                            size={18}
                                            className="fill-yellow-400 text-yellow-400"
                                        />
                                    ))}
                                </div>

                                <div className="flex items-center gap-4">

                                    <img
                                        src={item.image}
                                        alt={item.name}
                                        className="w-14 h-14 rounded-full object-cover"
                                    />

                                    <div>
                                        <h4 className="font-bold text-gray-900 dark:text-white">
                                            {item.name}
                                        </h4>

                                        <p className="text-sm text-gray-500">
                                            {item.location}
                                        </p>
                                    </div>

                                </div>

                            </div>

                        </SwiperSlide>
                    ))}
                </Swiper>

            </div>
        </section>
    );
}